import { render, staticRenderFns } from "./UnlockedList.vue?vue&type=template&id=c4599494&"
import script from "./UnlockedList.vue?vue&type=script&lang=ts&"
export * from "./UnlockedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports